/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Locale_Banner_DismissInputs */



/**
* | output |
* | --- |
* | "Dismiss language notice" |
*
* @param {Locale_Banner_DismissInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const locale_banner_dismiss = /** @type {((inputs?: Locale_Banner_DismissInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Locale_Banner_DismissInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Sprachhinweis schließen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fermer l'avis de langue")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("关闭语言提示")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("關閉語言提示")
	if (locale === "ko") return /** @type {LocalizedString} */ ("언어 안내 닫기")
	return /** @type {LocalizedString} */ ("Dismiss language notice")
});